// latest: zhangmyh 2017-10-17 21:39 PM
import { Model } from 'common'
// 指标子表
Model.define('templatelib_field_certification.indicator', {
  meta: {
    id: '',
    indicatorClassId: '',
    indicatorClassName: '',
    indicatorDescription: '',
    indicatorScoreBasis: '',
    indicatorName: '',
    templetId: '',
    isDecision: '',
    weight: '',
    indicatorType: '',
    indicatorId: '',
    orderNo: '', // 排序编号
    ag_changed: '' // 是否改变
  }
})



// WEBPACK FOOTER //
// ./src/data/model/tplFieldCertification/indicator.js